import { IoMailOpenOutline, IoMailUnreadOutline } from 'react-icons/io5';

interface MailIconProps {
  hasUnread: boolean;
  isHovered: boolean;
  size?: number;
}

export default function MailIcon({
  hasUnread,
  isHovered,
  size = 24,
}: MailIconProps) {
  if (isHovered) {
    return hasUnread ? (
      <IoMailOpenOutline size={size} />
    ) : (
      <IoMailUnreadOutline size={size} />
    );
  }
  return hasUnread ? (
    <IoMailUnreadOutline size={size} />
  ) : (
    <IoMailOpenOutline size={size} />
  );
}
